import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./ColorInputBox.module.css";

const ColorInputBox = ({ setValue, value, placeholder }) => {
  const [inputValue, setInputValue] = useState(value || "");
  const [color, setColor] = useState("");

  useEffect(() => {
    // Regex updated to allow 6 OR 8 characters after the #
    if (/^#([0-9A-F]{6}|[0-9A-F]{8})$/i.test(value)) {
      setColor(value);
      setInputValue(value);
    } else if (!value) {
      setInputValue("");
      setColor("");
    }
  }, [value]);

  const updateColor = (newValue) => {
    let formattedValue = newValue;

    if (newValue && /^[0-9A-F]/i.test(newValue[0]) && !newValue.startsWith("#")) {
      formattedValue = `#${newValue}`;
    }

    formattedValue = formattedValue.slice(0, 9);

    setInputValue(formattedValue);

    if (/^#([0-9A-F]{6}|[0-9A-F]{8})$/i.test(formattedValue)) {
      setColor(formattedValue);
      setValue(formattedValue); // Pass the hex8 back to the parent
    } else {
      // show the preview if it's at least a valid 6-digit hex during typing
      if (/^#([0-9A-F]{6})$/i.test(formattedValue)) {
        setColor(formattedValue);
      } else {
        setColor("");
      }
    }
  };

return (
    <div className={styles.colorInputContainer}>
      <input
        type="text"
        value={inputValue}
        onChange={(e) => updateColor(e.target.value)}
        placeholder={placeholder}
        className={styles.colorInputField}
      />
      <div
        className={styles.colorPreviewBox}
        style={{ 
          position: "relative",
          overflow: "hidden",
          borderRadius: "4px",
          border: "1px solid #eee"
        }}
      >
        <div style={{
          position: "absolute",
          inset: 0,
          backgroundImage: "conic-gradient(#ccc 25%, #fff 25%, #fff 75%, #ccc 75%)",
          backgroundSize: "8px 8px",
          zIndex: 1
        }} />

        <div style={{
          position: "absolute",
          inset: 0,
          backgroundColor: color || "transparent",
          zIndex: 2
        }} />
      </div>
    </div>
  );
};

ColorInputBox.propTypes = {
  setValue: PropTypes.func.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
};

export default ColorInputBox;